export enum MediaType {
  EXTERNAL_VIDEO = "external_video",
  MEDIA = "media",
}
